import cookie_key from "constants/SESSION_COOKIE_NAME"
import cookie_get from "frontend/utils/cookie_get"
import user_get from "workflow/utils/user_get"

export default () => {
  return user_get(cookie_get(cookie_key))
}
